export const MOUNT_SURVEY_LIST = 'MOUNT_SURVEY_LIST';
export const SORT_SURVEY_LIST_COLUMN = 'SORT_SURVEY_LIST_COLUMN';

export const ON_SURVEY_SEARCH = 'ON_SURVEY_SEARCH';
export const LOAD_SURVEY_LIST = 'LOAD_SURVEY_LIST';
export const SURVEY_TAB_CHANGE = 'SURVEY_TAB_CHANGE';
export const TOGGLE_SURVEY_FAVORITE = 'TOGGLE_SURVEY_FAVORITE';
export const CHANGE_SURVEY_STATUS = 'CHANGE_SURVEY_STATUS';
export const CHANGE_SURVEY_SHOW_IN_MENU_VALUE = 'CHANGE_SURVEY_SHOW_IN_MENU_VALUE';
export const GO_BACK_TO_SURVEY_LIST = 'GO_BACK_TO_SURVEY_LIST';
export const FORWARD_TO_ANALYTICS = 'FORWARD_TO_ANALYTICS';

export const LOAD_SURVEY_LIST_PREVIEW_OPTIONS = 'LOAD_SURVEY_LIST_PREVIEW_OPTIONS';
export const LOAD_MORE_SURVEY_LIST_PREVIEW_OPTIONS = 'LOAD_MORE_SURVEY_LIST_PREVIEW_OPTIONS';
export const SET_SURVEY_LIST_PREVIEW_OPTIONS = 'SET_SURVEY_LIST_PREVIEW_OPTIONS';
export const ADD_SURVEY_LIST_PREVIEW_OPTIONS = 'ADD_SURVEY_LIST_PREVIEW_OPTIONS';
export const SET_SURVEY_LIST_PREVIEW_OPTIONS_COUNT = 'SET_SURVEY_LIST_PREVIEW_OPTIONS_COUNT';
export const SET_SURVEY_LIST_PREVIEW_TEXT = 'SET_SURVEY_LIST_PREVIEW_TEXT';

export const SURVEY_LIST_ACTION_EDIT = 'SURVEY_LIST_ACTION_EDIT';
export const SURVEY_LIST_ACTION_CLONE = 'SURVEY_LIST_ACTION_CLONE';
export const SURVEY_LIST_ACTION_DELETE = 'SURVEY_LIST_ACTION_DELETE';
export const SURVEY_LIST_ACTION_ARCHIVE = 'SURVEY_LIST_ACTION_ARCHIVE';
export const SURVEY_LIST_ACTION_UNARCHIVE = 'SURVEY_LIST_ACTION_UNARCHIVE';
export const SURVEY_LIST_OPEN_DELETE_MODAL = 'SURVEY_LIST_OPEN_DELETE_MODAL';
export const SURVEY_LIST_OPEN_ARCHIVE_MODAL = 'SURVEY_LIST_OPEN_ARCHIVE_MODAL';
export const NAVIGATE_TO_SURVEY_QUICK_VIEW = 'NAVIGATE_TO_SURVEY_QUICK_VIEW';

export const POST_CREATE_SURVEY_REQUEST = 'POST_CREATE_SURVEY_REQUEST';
export const POST_CREATE_SURVEY_SUCCESS = 'POST_CREATE_SURVEY_SUCCESS';
export const POST_CREATE_SURVEY_FAILURE = 'POST_CREATE_SURVEY_FAILURE';

export const PATCH_SURVEY_STATUS_REQUEST = 'PATCH_SURVEY_STATUS_REQUEST';
export const PATCH_SURVEY_STATUS_SUCCESS = 'PATCH_SURVEY_STATUS_SUCCESS';
export const PATCH_SURVEY_STATUS_FAILURE = 'PATCH_SURVEY_STATUS_FAILURE';

export const PATCH_SURVEY_SHOW_IN_MENU_REQUEST = 'PATCH_SURVEY_SHOW_IN_MENU_REQUEST';
export const PATCH_SURVEY_SHOW_IN_MENU_SUCCESS = 'PATCH_SURVEY_SHOW_IN_MENU_SUCCESS';
export const PATCH_SURVEY_SHOW_IN_MENU_FAILURE = 'PATCH_SURVEY_SHOW_IN_MENU_FAILURE';

export const POST_CLONE_SURVEY_REQUEST = 'POST_CLONE_SURVEY_REQUEST';
export const POST_CLONE_SURVEY_SUCCESS = 'POST_CLONE_SURVEY_SUCCESS';
export const POST_CLONE_SURVEY_FAILURE = 'POST_CLONE_SURVEY_FAILURE';

export const DELETE_SURVEY_REQUEST = 'DELETE_SURVEY_REQUEST';
export const DELETE_SURVEY_SUCCESS = 'DELETE_SURVEY_SUCCESS';
export const DELETE_SURVEY_FAILURE = 'DELETE_SURVEY_FAILURE';

export const BATCH_SURVEYS_STATUS_REQUEST = 'BATCH_SURVEYS_STATUS_REQUEST';
export const BATCH_SURVEYS_STATUS_SUCCESS = 'BATCH_SURVEYS_STATUS_SUCCESS';
export const BATCH_SURVEYS_STATUS_FAILURE = 'BATCH_SURVEYS_STATUS_FAILURE';

export const GET_SURVEY_LIST_PREVIEW_OPTIONS_REQUEST = 'GET_SURVEY_LIST_PREVIEW_OPTIONS_REQUEST';
export const GET_SURVEY_LIST_PREVIEW_OPTIONS_SUCCESS = 'GET_SURVEY_LIST_PREVIEW_OPTIONS_SUCCESS';
export const GET_SURVEY_LIST_PREVIEW_OPTIONS_FAILURE = 'GET_SURVEY_LIST_PREVIEW_OPTIONS_FAILURE';
